import { Field, Form, Formik, FormikHelpers } from 'formik'
import { FC, ReactElement } from 'react'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useHistory } from 'react-router'
import * as yup from 'yup'
import Button from '../../components/button'
import Input from '../../components/input'
import config from '../../config'
import { useAuth } from '../../hooks/auth'
import { RoutesEnum } from '../../utils/routesEnum'
import PasswordSkeleton from './skeleton'

const schema = yup.object().shape({
  email: yup.string().email('Email inválido').required('Email obrigatório')
})

const ForgotPassword: FC = (): ReactElement => {
  const initialValues = {
    email: ''
  }

  const history = useHistory()

  const { askCode } = useAuth()

  const { executeRecaptcha } = useGoogleReCaptcha()

  const submit = async (values: typeof initialValues, helpers: FormikHelpers<typeof initialValues>): Promise<void> => {
    helpers.setSubmitting(true)
    try {
      const captcha = executeRecaptcha ? await executeRecaptcha() : undefined
      await askCode(values.email, captcha)
      history.push(RoutesEnum.FORGOT_PASSWORD_VERIFICATION_CODE)
    } catch { }
    helpers.setSubmitting(false)
  }

  return (
    <PasswordSkeleton>
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={submit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Field
              component={Input}
              name='email'
              label='E-mail'
              type='email'
            />
            <div className='buttons'>
              <Button isLoading={isSubmitting} block type='submit'>Receber Código</Button>
              {/* <br /> */}
              <Button to={RoutesEnum.LOGIN} block variant='link'>Quer fazer login? Clique aqui!</Button>
            </div>
          </Form>
        )}
      </Formik>
    </PasswordSkeleton>
  )
}

const ForgotPasswordWithRecaptcha: FC = (props): ReactElement => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA_TOKEN}>
      <ForgotPassword {...props} />
    </GoogleReCaptchaProvider>
  )
}

export default ForgotPasswordWithRecaptcha
